{
  "id": 42,
  "location": "paris",
  "difficulty": "normal",
  "moves": 17,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "croissant", "count": 26 }
  ],
  "stars": [3230, 4200],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.788, "movesLeft": 4.7, "closeLosses": 0.108, "target": 0.68 }
}
